module.exports = __webpack_public_path__ + "img/125.303b5dd9.png";